<template>
    <div ref="logo-container" class="logo">
        <div v-if="loading && (!logoUrl || logoUrl == null)" class="h-100 w-100 d-flex justify-content-center align-items-center">
            <b-spinner small />
        </div>
        <img v-if="logoUrl" :src="logoUrl" :alt="logoAlt" />
        <div v-else class="no-logo d-flex justify-content-center align-items-center">
            <p v-show="showNoLogoText" ref="no-logo-text" :title="noLogoText">{{ noLogoText }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: Number | String,
            default: 32,
        },
        logoUrl: {
            type: String,
        },
        logoAlt: {
            type: String,
            default: '',
        },
        noLogoBackgroundColor: {
            type: String,
            default: 'var(--secondary-3)',
        },
        noLogoText: {
            type: String,
            default: '',
        },
        showNoLogoText: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        size() {
            this.setupProps()
        },
    },
    methods: {
        setupProps() {
            let logoContainer = this.$refs['logo-container']
            let noLogoText = this.$refs['no-logo-text']
            // Logo container
            if (logoContainer) {
                logoContainer.style.width = this.size + 'px'
                logoContainer.style.height = this.size + 'px'
                if (!this.logoUrl) logoContainer.style.background = this.noLogoBackgroundColor
            }

            // No logo text
            if (noLogoText) {
                noLogoText.style.fontSize = this.size / 6 + 'px'
            }
        },
    },
    mounted() {
        this.setupProps()
    },
}
</script>

<style lang="scss" scoped>
.logo {
    border-radius: 4px;
    img {
        border-radius: 4px;
        height: 100%;
        width: 100%;
    }
    .no-logo {
        height: 100%;
        width: 100%;
        p {
            font-size: 100%;
            margin: 0px;
            padding: 0px;
        }
    }
}
</style>
